import { Dropdown } from "primereact/dropdown";
import { Image } from "primereact/image";
import { useRef, useState } from "react";

import { ChevronDownIcon } from "primereact/icons/chevrondown";
import { ChevronUpIcon } from "primereact/icons/chevronup";

import iconForward from "assets/icons/icon_forward.svg";

import {
  formSendMessage,
  insertAnArgument,
  simonBot,
  startToMessage,
} from "_constants";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import { useAppDispatch, useAppSelector } from "store/store";
import { TextareaInput } from "components/shared";
import { Control } from "react-hook-form";
import { setRepliedAnswer } from "store/slicer/GestioneChatSlice";
import { TemplateDropdown } from "./template/TemplateDropdown";

export const InputTextMessage = ({
  control,
  setValue,
  answerType,
  onHeightChange,
  onSubmit,
}: {
  control: Control<any>;
  setValue: any;
  answerType: { className: string; name: string };
  onHeightChange: any;
  onSubmit: any;
}) => {
  const typeToneOfVoice = [
    { name: "Formale", code: "0" },
    { name: "Bilanciata", code: "0.5" },
    { name: "Creativa", code: "1" },
  ];
  const dispatch = useAppDispatch();
  const inputTextMessageRef = useRef<HTMLDivElement>(null);

  const count = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.count
  );
  const waitMessage = useAppSelector(
    (state) => state.gestioneChatSlice.waitMessage
  );
  const newMessage = useAppSelector(
    (state) => state.gestioneChatSlice.newMessage
  );
  const repliedAnswer = useAppSelector(
    (state) => state.gestioneChatSlice.repliedAnswer
  );
  const [toneOfVoice, setToneOfVoice] = useState(typeToneOfVoice[0]);

  const onChangeToneOfVoice = (value: any) => {
    setToneOfVoice(value);
    setValue("toneOfVoice", value.code);
  };

  const onInput = (e: any) => {
    if (e.key === "Enter" && e.shiftKey) {
      if (inputTextMessageRef.current) {
        onHeightChange(inputTextMessageRef!.current!.clientHeight);
      }
      return "\n";
    } else if (e.key === "Enter") {
      e.preventDefault();
      onSubmit();
      return "";
    }
    if (inputTextMessageRef.current) {
      onHeightChange(inputTextMessageRef!.current!.clientHeight);
    }
  };

  const resetToneOfVoice = () => {
    setToneOfVoice(typeToneOfVoice[0]);
  };

  return (
    <div
      className="input-message width-100 radius-12 align-center"
      ref={inputTextMessageRef}
    >
      <div className="tone-of-voice-dropdown min-height-61 height-100">
        <Dropdown
          value={toneOfVoice}
          onChange={(e) => onChangeToneOfVoice(e.value)}
          options={typeToneOfVoice}
          optionLabel="name"
          className="padd-right-13 height-100 border-radius-right-none flex-container align-center box-shadow-none"
          variant="filled"
          disabled={!count || waitMessage || newMessage}
          valueTemplate={(option) =>
            option ? <TemplateDropdown option={option} /> : null
          }
          dropdownIcon={(opts: any) => {
            return opts.iconProps["data-pr-overlay-visible"] ? (
              <ChevronUpIcon {...opts.iconProps} />
            ) : (
              <ChevronDownIcon {...opts.iconProps} />
            );
          }}
        />
      </div>
      <IconField className="width-100 custom-icon-field-textarea">
        <InputIcon className="custom-button-send-message">
          <Button
            type="submit"
            form={formSendMessage}
            icon={PrimeIcons.ARROW_RIGHT}
            onClick={resetToneOfVoice}
          />
        </InputIcon>
        {repliedAnswer && (
          <div className="height-px-61 header-input-message">
            <div className="flex-container height-100 align-center">
              <Image src={iconForward} alt="" width="24px" height="24px" />
            </div>
            <div className="divider-answer"></div>
            <div className="flex-container column width-80">
              <span className="text-title-bold">{simonBot}</span>
              <span className="text-regular-blue ellipsis-text">
                {repliedAnswer}
              </span>
            </div>
            <Button
              type="button"
              text
              icon={PrimeIcons.TIMES}
              onClick={() => dispatch(setRepliedAnswer(""))}
              className="remove-replied-answer"
              disabled={!count || waitMessage || newMessage}
            />
          </div>
        )}
        {answerType.name && (
          <div
            className={`container-type-answer ${
              repliedAnswer ? "replied" : ""
            }`}
          >
            <span className="text-base-regular-semibold ">
              {`/${answerType.name}`}
            </span>
          </div>
        )}
        <TextareaInput
          control={control}
          name="message"
          placeholder={answerType.name ? insertAnArgument : startToMessage}
          disabled={!count || waitMessage || newMessage}
          onlyLetters={false}
          noEmoji={false}
          showError={false}
          onInput={onInput}
          height="calc(100% - 61px)"
          template={`${
            repliedAnswer ? "custom-textarea-replied-answer" : ""
          } border-radius-left-none width-100 custom-textarea-input-message ${
            answerType.className
          }`}
          maxLength={8192}
        />
      </IconField>
    </div>
  );
};
